import { useMemo } from 'react';
import { useOverviewLinkState } from '../linkstate/ReportsOverview.linkstate';
import { ReportsQueryFilter } from '../../../../shared/types';
import { useUserState } from '../../../../Hooks/useUserState';
import { useGetReportsCountersTaxiBusinessQuery } from '../../../../GraphQL/hooks/useGetReportsCountersTaxiBusinessQuery';

export const useSortedReportsCountersTaxiBusinessQuery = () => {
    const [state] = useOverviewLinkState();
    const { quickCalendarFilter, selectedDateRange } = state;
    const { ...userState } = useUserState();

    const request = useMemo(
        () =>
            ({
                quicklyCalanderSlot: quickCalendarFilter ?? '',
                dateRange: selectedDateRange,
                operatorId: userState.operatorId,
            }) as ReportsQueryFilter,
        [quickCalendarFilter, selectedDateRange]
    );

    const {
        data: countersTaxiBusinessData,
        refetch,
        loading: loadingTaxiBusinessCounters,
    } = useGetReportsCountersTaxiBusinessQuery(request);

    return {
        countersTaxiBusinessData,
        refetchTaxiBusinessCounters: () => refetch({ request }),
        loadingTaxiBusinessCounters,
    };
};
